module.exports = __webpack_public_path__ + "assets/img/ad1.4ba45797.svg";